"use client"
import Title from "../Title/Title"
import "aos/dist/aos.css"

interface CardProps {
  title: string
  description: string
  titleClassName?: string
  descClassName?: string
  className?: string
  titleType?: "h1" | "h2" | "h3" | "h4" | "100" | "60" | "34" | "48"
  number: string
  numClasses?: string
  delay?: string
}

function Card({
  title,
  description,
  titleClassName = "",
  descClassName = "",
  className = "",
  titleType = "h4",
  number,
  numClasses = "",
  delay,
}: CardProps) {
  return (
    <div
      className={`card-number
                  p-4
                  md:p-6
                  h-fit
                  xl:min-h-[320px]
                  md:min-h-[520px]
                  flex flex-col justify-between
                  w-full ${className}`}
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-delay={delay} // Staggered delay based on the number
    >
      <div>
        {number && (
          <span
            className={`${numClasses} blog text-[36px] 4xl:text-[128px] 2xl:text-[184px] uppercase font-semibold font-oswald`}
          >
            {number}
          </span>
        )}
        <Title title={title} type={titleType} className={titleClassName} />
      </div>
      <p
        className={` text-[--color-dark] 2xl:text-[24px]  text-lg font-normal ${descClassName} leading-[150%]`}
      >
        {description}
      </p>
    </div>
  )
}

export default Card
